module.exports = __webpack_public_path__ + "static/media/9.87929d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/9.png
// module id = 1545
// module chunks = 0